import React from "react";
import { connect } from "react-redux";
import { extend } from "lodash";

// import { initRouter } from '../actions/routerActions';
// import { getUserByJwt } from './../../actions/UserActions';
import { browserHistory, withRouter } from 'react-router';
import { env } from 'configs/nodeConfig';

import Constants from "./../constants";
import {
    HomeContainer,
    SearchContainer,
    CheckoutContainer,
    ProductDetails,
    ConfirmationContainer,
    InvoiceContainer,
    AmendmentInvoiceContainer,
    MyProfileContainer,
    MyBookingContainer,
    AmendmentContainer,
    HcnUpdateContainer
} from './LoadableContainer';
import { hot } from 'react-hot-loader';

import Root from "components/Root/Root";


const RootContainer = props => <Root {...props} />;
const mapStateToProps = state => {
    const {
    } = state;

    var pathMapping = [
        Constants.routes.HOMEPAGE,
        Constants.routes.SEARCH,
        Constants.routes.CHECKOUT,
        Constants.routes.PRODUCT,
        Constants.routes.CONFIRMATION,
        Constants.routes.INVOICE,
        Constants.routes.CORRECTION_AMENDMENT,
        Constants.routes.MY_PROFILE,
        Constants.routes.MY_BOOKING,
        Constants.routes.AMENDMENT,
        Constants.routes.HCN_UPDATE
    ];
    var urlMapping = {
        [Constants.routes.HOMEPAGE]: HomeContainer,
        [Constants.routes.SEARCH]: SearchContainer,
        [Constants.routes.CHECKOUT]: CheckoutContainer,
        [Constants.routes.PRODUCT]: ProductDetails,
        [Constants.routes.CONFIRMATION]: ConfirmationContainer,
        [Constants.routes.INVOICE]: InvoiceContainer,
        [Constants.routes.CORRECTION_AMENDMENT]: AmendmentInvoiceContainer,
        [Constants.routes.MY_PROFILE]: MyProfileContainer,
        [Constants.routes.MY_BOOKING]: MyBookingContainer,
        [Constants.routes.AMENDMENT]: AmendmentContainer,
        [Constants.routes.HCN_UPDATE]: HcnUpdateContainer,

    };
    var postQuoteList = {};

    /**
     * this assigns postQuoteList to urlMaping
     * and mutates urlMapping with postQuoteList property and propert in urlMapping
     *  having same key as postQuoteList will be overridden
     */
    urlMapping = extend(urlMapping, postQuoteList);

    return {
        paths: pathMapping,
        routes: urlMapping
    };
};

const mapDispatchToProps = dispatch => ({
    getUserByJwt() {

        // dispatch(getUserByJwt())
    }
})

let appContainer = '';
if (env === 'development') {
    appContainer = hot(module)(withRouter(connect(
        mapStateToProps,
        mapDispatchToProps
    )(RootContainer)));
} else {
    appContainer = withRouter(connect(
        mapStateToProps,
        mapDispatchToProps
    )(RootContainer));
}

export default appContainer;
